import useIsConsentGranted from '@alltrails/layout/hooks/UseIsConsentGranted';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const useSprigEvent = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const isConsentGranted = useIsConsentGranted();

  useEffect(() => {
    // Sprig handles this check for us but the Sprig script we need to send events with is not loaded until the consent is granted
    if (!isConsentGranted) {
      return;
    }

    const key = searchParams.get('sprig');

    let event;
    if (key === 'custom-route-exited') {
      event = {
        eventName: 'Custom_Route_Exited'
      };
    }

    if (event) {
      window.Sprig?.('identifyAndTrack', event);
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.delete('sprig');

      const newParamsString = newParams.toString() ? `?${newParams.toString()}` : '';
      router.replace(`${pathname}${newParamsString}`);
    }
  }, [searchParams, router, pathname, isConsentGranted]);
};

export default useSprigEvent;
